var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayIconWhiteCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.603,
    height: 16.61,
    viewBox: "0 0 16.603 16.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M8.314,0A8.305,8.305,0,1,1,0,8.309,8.3,8.3,0,0,1,8.314,0Zm7.629,8.3a7.639,7.639,0,1,0-7.6,7.649,7.644,7.644,0,0,0,7.6-7.649Z",
    transform: "translate(0 0)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M133.85,109.911q0-1.454,0-2.909a.774.774,0,0,1,1.223-.711l5.126,2.94a.769.769,0,0,1,.006,1.381q-2.578,1.476-5.159,2.946a.768.768,0,0,1-1.182-.5,1.132,1.132,0,0,1-.014-.222q0-1.462,0-2.925Z",
    transform: "translate(-128.124 -101.612)",
    fill: "#0d0d0d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconWhiteCard);
export default __webpack_public_path__ + "static/media/playIconWhiteCard.c9fc28a3eab91544e273354cca32e5e2.svg";
export { ForwardRef as ReactComponent };